<template>
  <div class="header-container">
    <img class="logo" alt="Synology Drive">
    <button @click="goToHelp" class="help-button"></button>
  </div>
</template>

<script setup>
const link = 'https://kb.synology.com/DSM/help/SynologyDrive/drive_file_management?version=7#filerequest'

const goToHelp = () => {
  window.open(link, '_blank')
}

</script>

<style lang="scss" scoped>
.header-container {
  position: fixed;
  width: 100%;
  height: 50px;
  display: flex;
  text-align: left;
  background: #FFF;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 7px 20px;
  z-index: 1;
  -webkit-user-select: none;
  user-select: none;
  .logo {
    content: url('@/assets/logo_synology_drive.svg');
  }
  .help-button {
    background: transparent;
    width: 24px;
    height: 24px;
    border: none;
    cursor: pointer;
    background-image: url('@/assets/ic_help.svg');
    &:hover {
      background-position: 0 -24px;
    }
    &:active {
      background-position: 0 -48px;
    }
  }
}
</style>